import { useEffect, useState } from "react";
import { addWorkType, getAllWorkTypes, toggleWorkTypeStatus, updateWorkType } from "../../services/AdminServices";
import WorkTypeList from "../../components/AdminComponents/PagesComponents/WorkTypes/WorkTypeList";
import AddWorkTypeModal from "../../components/AdminComponents/PagesComponents/WorkTypes/AddWorkTypeModal";
import ConfirmActionModal from "../../components/AdminComponents/Modals/ConfirmActionModal";
import MessageModal from "../../components/AdminComponents/Modals/MessageModal";

const AdminWorkTypePage = () => {
    const [editData, setEditData] = useState(null);
    const [openModal, setOpenModal] = useState(false);

    const [workTypes, setWorkTypes] = useState([]);

    const [loading, setLoading] = useState(false);

    const [confirmModal, setConfirmModal] = useState({
        open: false,
        WorkType: null,
    });

    const [messageModal, setMessageModal] = useState({
        open: false,
        type: "success",
        title: "",
        message: "",
    });


    const showSuccess = (msg) => {
        setMessageModal({
            open: true,
            type: "success",
            title: "Success",
            message: msg,
        });
    };

    const showError = (msg) => {
        setMessageModal({
            open: true,
            type: "error",
            title: "Error",
            message: msg,
        });
    };

    const handleToggleRequest = (WorkType) => {
        setConfirmModal({ open: true, WorkType });
    };

    const handleConfirmToggle = async () => {
        try {
            await toggleWorkTypeStatus(confirmModal.WorkType.id);
            await loadWorkTypes();
            showSuccess(confirmModal.WorkType.active ? "WorkType deactivated successfully" : "WorkType activated successfully");
        } catch (err) {
            showError(err?.response?.data?.message || "Something went wrong");
        } finally {
            setConfirmModal({ open: false, WorkType: null });
        }
    };

    const loadWorkTypes = async () => {
        console.log("Fetching WorkTypes...")
        try {
            setLoading(true);
            const res = await getAllWorkTypes();
            if (res.success) {
                setWorkTypes(res.data);
                console.log("Fetched WorkTypes Successfully.", res.data);
            }

        } catch (err) {
            console.error(err?.response?.data?.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadWorkTypes();
    }, [])

    const handleSave = async (formData) => {
        try {
            console.log(formData);
            let res;
            if (editData) {
                res = await updateWorkType(editData.id, formData);
            } else {
                res = await addWorkType(formData);
            }

            if (res.success) {
                await loadWorkTypes();
                setOpenModal(false);
                setEditData(null);
                showSuccess(res.message);
            }
        } catch (err) {
            showError(err?.response?.data?.message || "Something went wrong");
        }
    }


    return (
        <div className="p-4 admin-card-box space-y-4">
            <div className="flex justify-between items-center">
                <h2 className="admin-heading text-blue">Work Types</h2>
                <button
                    className="btnAdd"
                    onClick={() => {
                        setEditData(null);
                        setOpenModal(true);
                    }}
                >
                    + Add Work Type
                </button>
            </div>
            <WorkTypeList
                data={workTypes}
                loading={loading}
                onEdit={(d) => {
                    setEditData(d);
                    setOpenModal(true);
                }}
                onToggle={handleToggleRequest}
            />

            <AddWorkTypeModal
                open={openModal}
                editData={editData}
                onClose={() => {
                    setOpenModal(false);
                    setEditData(null);
                }}
                onSave={handleSave}
            />


            <ConfirmActionModal
                open={confirmModal.open}
                title={
                    confirmModal.WorkType?.active
                        ? "Deactivate Work Type"
                        : "Activate Work Type"
                }
                message={
                    confirmModal.WorkType?.active
                        ? "Do you really want to deactivate this work type?"
                        : "Do you want to activate this work type again?"
                }
                confirmText={
                    confirmModal.WorkType?.active ? "DEACTIVATE" : "ACTIVATE"
                }
                onConfirm={handleConfirmToggle}
                onClose={() =>
                    setConfirmModal({ open: false, WorkType: null })
                }
            />

            <MessageModal
                open={messageModal.open}
                type={messageModal.type}
                title={messageModal.title}
                message={messageModal.message}
                onClose={() =>
                    setMessageModal({ ...messageModal, open: false })
                }
            />


        </div>
    )
}

export default AdminWorkTypePage;